const wrapper = "_araw1oityuc";
const saveIndicator = "_aras1v7g9e9";

export { saveIndicator, wrapper };
import "./integration.save-indicator.style.linaria.module.css";
//# sourceMappingURL=integration.save-indicator.style.js.map
